
export default {
  data() {
    return {
      hasLeft: false,
    };
  },

  computed: {
    customer() {
      return this.$get(this.$$users, "user", "");
    },
  },

  methods: {
    toggleSidebar() {
      this.hasLeft = !this.hasLeft;
    },

    showAccountAction() {
      const refAccountAction = this.$refs.refAccountAction;
      refAccountAction && refAccountAction.classList.toggle("show");
    },

    closeDropdown() {
      const refAccountAction = this.$refs.refAccountAction;
      refAccountAction && refAccountAction.classList.remove("show");
    },
  },
};
